var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"p-4 text-center"})
}
var staticRenderFns = []

export { render, staticRenderFns }